"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _react = _interopRequireDefault(require("react"));
var _ActionButton = _interopRequireDefault(require("../ActionButton"));
var _events = require("../events");
var styles = {
  "label": "Actions__label__15Qj9",
  "popover": "Actions__popover__PUPy4",
  "more-actions": "Actions__more-actions__29ryr",
  "moreActions": "Actions__more-actions__29ryr",
  "delete-item": "Actions__delete-item__a5tmt",
  "deleteItem": "Actions__delete-item__a5tmt",
  "more-options": "Actions__more-options__2ZZJW",
  "moreOptions": "Actions__more-options__2ZZJW",
  "menu": "Actions__menu__2p9za",
  "menu-item": "Actions__menu-item__16n8N",
  "menuItem": "Actions__menu-item__16n8N",
  "popover-action": "Actions__popover-action__3AouI",
  "popoverAction": "Actions__popover-action__3AouI",
  "detail-actions": "Actions__detail-actions__1JuFL",
  "detailActions": "Actions__detail-actions__1JuFL",
  "visible": "Actions__visible__3wTwb",
  "first-action": "Actions__first-action__22GQj",
  "firstAction": "Actions__first-action__22GQj",
  "disabled": "Actions__disabled__kl_U-",
  "action": "Actions__action__183fJ",
  "detail-actions-pira": "Actions__detail-actions-pira__2_tT7",
  "detailActionsPira": "Actions__detail-actions-pira__2_tT7",
  "deprecate-icon": "Actions__deprecate-icon__1-0EU",
  "deprecateIcon": "Actions__deprecate-icon__1-0EU",
  "label-pira": "Actions__label-pira__1lsDh",
  "labelPira": "Actions__label-pira__1lsDh",
  "public-portal-actions-container": "Actions__public-portal-actions-container__33sgK",
  "publicPortalActionsContainer": "Actions__public-portal-actions-container__33sgK"
}; 
require('../Actions.css');
var PublicPortalActions = function PublicPortalActions(_ref) {
  var asset = _ref.asset,
    actions = _ref.actions,
    isStudio = _ref.isStudio,
    isEdit = _ref.isEdit,
    isDraft = _ref.isDraft;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "public-portal-actions",
    className: styles.publicPortalActionsContainer
  }, actions({
    isStudio: isStudio,
    isEdit: isEdit,
    isDraft: isDraft,
    section: 'public-portal-actions'
  }).map(function (action) {
    var label = action.label,
      description = action.description,
      actionId = action.id,
      icon = action.icon,
      href = action.href,
      tooltip = action.tooltip,
      _onClick = action.onClick;
    var key = "asset-action-".concat(actionId);
    return /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
      key: key,
      onClick: function onClick() {
        (0, _events.trackGenericActionEvent)({
          asset: asset,
          actionId: actionId,
          section: 'public-portal-actions',
          trackEvent: trackEvent
        });
        if (_onClick) {
          _onClick();
        }
      },
      href: href,
      icon: icon,
      label: label,
      description: description,
      tooltip: tooltip,
      testId: key
    });
  }));
};
var _default = exports.default = PublicPortalActions;
//# sourceMappingURL=PublicPortalActions.js.map